import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * 医薬品一覧
 *
 * 医薬品データの一覧を返す
 */
export class FetchPharmaceutical implements APIRequest<Monitaro.FetchPharmaceuticalResponse> {
  response: Monitaro.FetchPharmaceuticalResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/pharmaceuticals`
  }
}

/**
 * 医薬品データの追加
 *
 * 新規で医療品データを登録する
 */
export class PostPharmaceutical implements APIRequest<Monitaro.PostPharmaceuticalResponse> {
  response: Monitaro.PostPharmaceuticalResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  params: Monitaro.PharmaceuticalRequest
  constructor(params: Monitaro.PharmaceuticalRequest) {
    this.params = params
    this.path = `/pharmaceuticals`
  }
}

/**
 * 医薬品データの取得
 *
 * 指定されたIDの医薬品情報を返す
 */
export class GetPharmaceutical implements APIRequest<Monitaro.GetPharmaceuticalResponse> {
  response: Monitaro.GetPharmaceuticalResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(pharmaceutical: string) {
    this.path = `/pharmaceuticals/${pharmaceutical}`
  }
}

/**
 * 医薬品データの更新
 *
 * 指定されたIDの医薬品データ更新する
 */
export class PutPharmaceutical implements APIRequest<Monitaro.PutPharmaceuticalResponse> {
  response: Monitaro.PutPharmaceuticalResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.PUT
  params: Monitaro.PharmaceuticalRequest
  constructor(pharmaceutical: string, params: Monitaro.PharmaceuticalRequest) {
    this.params = params
    this.path = `/pharmaceuticals/${pharmaceutical}`
  }
}
